/**
 * Valide si une chaîne est un email au format standard.
 * @param email string à valider
 * @returns true si email valide, false sinon
 */
export function u2000IsValidEmail(email: string): boolean {
  if (typeof email !== "string") return false;
  // Regex robuste mais tolérante (RFC 5322 simplifiée)
  return /^[\w.!#$%&'*+/=?^_`{|}~-]+@[\w-]+(\.[\w-]+)+$/.test(email.trim());
}
